export type RatingState = {
  thumbsUp: boolean | null
  ratingId: string | null
  rationale: string
}

export type RatingEffect =
  | { type: 'none' }
  | { type: 'create'; thumbsUp: boolean; rationale: string | null }
  | { type: 'delete'; ratingId: string }
  | {
      type: 'replace'
      deleteRatingId: string
      thumbsUp: boolean
      rationale: string | null
    }

export type RatingTransition = {
  state: RatingState
  effect: RatingEffect
}

export const initialRatingState: RatingState = {
  thumbsUp: null,
  ratingId: null,
  rationale: '',
}

export function rate(state: RatingState, thumbsUp: boolean): RatingTransition {
  if (state.thumbsUp === null) {
    return {
      state: { thumbsUp, ratingId: null, rationale: '' },
      effect: { type: 'create', thumbsUp, rationale: null },
    }
  }

  if (state.thumbsUp === thumbsUp) {
    if (state.ratingId === null) {
      return { state: initialRatingState, effect: { type: 'none' } }
    }
    return {
      state: initialRatingState,
      effect: { type: 'delete', ratingId: state.ratingId },
    }
  }

  if (state.ratingId === null) {
    return {
      state: { thumbsUp, ratingId: null, rationale: '' },
      effect: { type: 'create', thumbsUp, rationale: null },
    }
  }
  return {
    state: { thumbsUp, ratingId: null, rationale: '' },
    effect: {
      type: 'replace',
      deleteRatingId: state.ratingId,
      thumbsUp,
      rationale: null,
    },
  }
}

export function submitRationale(state: RatingState, text: string): RatingTransition {
  if (state.thumbsUp === null) {
    return { state, effect: { type: 'none' } }
  }

  const trimmed = text.trim()
  const wireRationale = trimmed === '' ? null : trimmed

  if (state.ratingId === null) {
    return {
      state: { ...state, rationale: trimmed },
      effect: { type: 'create', thumbsUp: state.thumbsUp, rationale: wireRationale },
    }
  }
  return {
    state: { ...state, ratingId: null, rationale: trimmed },
    effect: {
      type: 'replace',
      deleteRatingId: state.ratingId,
      thumbsUp: state.thumbsUp,
      rationale: wireRationale,
    },
  }
}

export function ratingCreated(state: RatingState, ratingId: string): RatingState {
  return { ...state, ratingId }
}
